import React from 'react';
import ReactDOM from 'react-dom';

import { Provider as ReduxProvider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';

import rootReducer from './reducers';
import { LanguageProvider } from './utils/LanguageContext';

import './scss/index.scss';

// import configureStore from './store/configureStore';

const store = createStore(rootReducer, applyMiddleware(thunk, logger));
// const { REACT_APP_PATH, NODE_ENV } = process.env;
// const basename = NODE_ENV === 'production' ? `${REACT_APP_PATH}/` : '/';
const basename = '/';

ReactDOM.render(
  <ReduxProvider store={store}>
    <LanguageProvider>
      <Router basename={basename}>
        <App />
      </Router>
    </LanguageProvider>
  </ReduxProvider>,
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js